import React from 'react';
import { Box, Typography,  Paper } from '@mui/material';
import {
  LineChart, ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, AreaChart, Area
} from 'recharts';
import { COLOR_MAP } from '../constants';

export default function DeviceCharts({ data }) {

  const weightDomain = (() => {
      const maxVal = Math.max(...data.map(d => d.weight || 0), 0);
      if (maxVal <= 40) return 40;
      if (maxVal <= 100) return 100;
      return 160;
    })();

  return (
      <>
      <Paper sx={{ p: 0, mb: 3 , mt: 4, borderRadius: 2, overflow: 'hidden' }}>
        <Box sx={{
          backgroundColor: 'greyCustom.soft',
          p: 1.5,
          borderBottom: '1px solid #e0e0e0'
        }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 'bold', pl: 1 }}
          >
            Βάρος (kg)
          </Typography>
        </Box>
        <Box sx={{ pt: 2, pb: 2, height: 340 }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 20, right: 40, left: -20, bottom: 0 }} >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="time" tick={{ fontSize: 12 }} />
              <YAxis domain={[0, weightDomain]}  tick={{ fontSize: 12 }}/>
              <Tooltip />
              <Area type="monotone" dataKey="weight" stroke={COLOR_MAP['yellow']} fill={COLOR_MAP['yellow']} fillOpacity={0.3} connectNulls={false} />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      </Paper>

      <Paper sx={{ p: 0, mb: 3, borderRadius: 2, overflow: 'hidden'  }}>
        <Box sx={{
          backgroundColor: 'greyCustom.soft',
          p: 1.5,
          borderBottom: '1px solid #e0e0e0'
        }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 'bold', pl: 1 }}
          >
            Θερμοκρασία / Υγρασία
          </Typography>
        </Box>
        <Box sx={{ pt: 2, pb: 2, height: 340 }}>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data} margin={{ top: 20, right: 40, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="time" tick={{ fontSize: 12 }}/>
              <YAxis domain={[0, 100]} tick={{ fontSize: 12 }}/>
              <Tooltip />
              <Line type="monotone" dataKey="temperature" stroke={COLOR_MAP['red']} name="Θερμοκρασία" strokeWidth={2} />
              <Line type="monotone" dataKey="humidity" stroke={COLOR_MAP['blue']} name="Υγρασία" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </Box>
      </Paper>

      <Paper sx={{ p: 0, borderRadius: 2, overflow: 'hidden' }}>
        <Box sx={{
          backgroundColor: 'greyCustom.soft',
          p: 1.5,
          borderBottom: '1px solid #e0e0e0'
        }}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 'bold', pl: 1 }}
          >
            Μπαταρία / Σήμα
          </Typography>
        </Box>
        <Box sx={{ pt: 2, pb: 2, height: 340 }}>
          <ResponsiveContainer width="100%" height="100%">
            <ComposedChart data={data}  margin={{ top: 20, right: 40, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="time" tick={{ fontSize: 12 }} />
              <YAxis domain={[0, 100]} tick={{ fontSize: 12 }} />
              <Tooltip />
              <Line type="monotone" dataKey="battery" stroke={COLOR_MAP['green']} name="Μπαταρία" strokeWidth={2} />
              <Bar dataKey="signal" barSize={20}  fill={COLOR_MAP['purple']} name="Σήμα" strokeWidth={2} />
            </ComposedChart>
          </ResponsiveContainer>
        </Box>
      </Paper>
    </>
  );
}
